import { render, staticRenderFns } from "./FailingAttributes.vue?vue&type=template&id=8680e14e&"
import script from "./FailingAttributes.vue?vue&type=script&lang=js&"
export * from "./FailingAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports